<!-- ===================================
     SECCIÓN BENEFICIOS - LA JOYA PARK RESORT
     =================================== -->

<section class="benefits-section">
  <div class="container">
    <!-- Header de la sección -->
    <div class="benefits-header">
      <h2>Beneficios como socio</h2>
      <p>Si formas parte de nuestro club resort La Joya, obtendrás beneficios únicos con tu membresía</p>
    </div>

    <!-- Cards de beneficios -->
    <div class="benefits-cards">
      <!-- Card 1: Membresías Exclusivas (Principal) -->
      <div class="benefit-card" 
           [class.expanded]="isCardExpanded('membership')"
           (click)="selectCard('membership')">
        <div class="card-image">
          <img [src]="getImageUrl('images/sections/benefits_card/membership.webp')" alt="Membresías Exclusivas">
          <div class="card-overlay">
            <h3>Membresías Exclusivas</h3>
            <p>Acceso ilimitado a 15 hectáreas de diversión. Tu familia, tu paraíso, tu lugar.</p>
          </div>
        </div>
        <div class="card-icon">
          <img [src]="getCardIcon('membership')" alt="Icono de expansión">
        </div>
      </div>

      <!-- Card 2: Eventos Exclusivos -->
      <div class="benefit-card" 
           [class.expanded]="isCardExpanded('events')"
           (click)="selectCard('events')">
        <div class="card-image">
          <img [src]="getImageUrl('images/sections/benefits_card/exclusive_party.webp')" alt="Eventos Exclusivos">
          <div class="card-overlay">
            <h3>Eventos Exclusivos</h3>
            <p>Shows y fiestas privadas para socios. Experiencias que no olvidarás.</p>
          </div>
        </div>
        <div class="card-icon">
          <img [src]="getCardIcon('events')" alt="Icono de expansión">
        </div>
      </div>

      <!-- Card 3: Acceso Exclusivo -->
      <div class="benefit-card" 
           [class.expanded]="isCardExpanded('access')"
           (click)="selectCard('access')">
        <div class="card-image">
          <img [src]="getImageUrl('images/sections/benefits_card/access.webp')" alt="Acceso Exclusivo">
          <div class="card-overlay">
            <h3>Acceso Todo el Año</h3>
            <p>Tu acceso privado siempre disponible. El paraíso nunca cierra para ti.</p>
          </div>
        </div>
        <div class="card-icon">
          <img [src]="getCardIcon('access')" alt="Icono de expansión">
        </div>
      </div>

      <!-- Card 4: Beneficios Generales -->
      <div class="benefit-card" 
           [class.expanded]="isCardExpanded('benefits')"
           (click)="selectCard('benefits')">
        <div class="card-image">
          <img [src]="getImageUrl('images/sections/benefits_card/benefits.webp')" alt="Beneficios Generales">
          <div class="card-overlay">
            <h3>Beneficios exclusivos de socio</h3>
            <p>Tu membresía incluye experiencias exclusivas. Privilegios diseñados solo para ti.</p>
          </div>
        </div>
        <div class="card-icon">
          <img [src]="getCardIcon('benefits')" alt="Icono de expansión">
        </div>
      </div>
    </div>
  </div>
</section>
